import React from 'react';
import './cerrar.css';

class Cerrado extends React.Component{

    render(){
        return <React.Fragment>
            <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#FFF" className="float__menu--button">
                <rect width="48" height="48" fillOpacity="0.01"/>
                <path d="M7.94977 11.9498H39.9498" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7.94977 23.9498H39.9498" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7.94977 35.9498H39.9498" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </React.Fragment>;
    }
}

export default Cerrado;